/**
 * @summary A reusable Logo component that can optionally be a link
 */
import React from 'react';
import { useRouter } from 'next/router';
import cx from 'utils/classnames';

interface LogoProps {
  siteName: string;
  logoLink?: { url: string; title: string; target: string };
  className?: string;
}

function Logo({
  siteName,
  logoLink,
  className = 'header__logo',
}: LogoProps): React.JSX.Element {
  const router = useRouter();
  const logoClass = cx({
    [className]: true,
  });

  // If logoLink is provided and current path doesn't contain the logoLink.url, render as Link
  if (logoLink?.url && !router?.asPath?.includes(logoLink.url)) {
    return (
      <a
        href={logoLink.url}
        className={logoClass}
        target={logoLink.target || undefined}
        rel={logoLink.target === '_blank' ? 'noreferrer noopener' : undefined}
      >
        <span className="isVisuallyHidden">{siteName}</span>
      </a>
    );
  }

  // Otherwise, render as a div (either no logoLink or current path matches logoLink.url)
  return (
    <div className={logoClass}>
      <span className="isVisuallyHidden">{siteName}</span>
    </div>
  );
}

export default Logo;
